/* ============================================================
   Premium Lightbox -- Maison Bruges
   Target: draft theme 'Copy of HORIZON MAIN 1.5'
   Self-contained; intercepts .product-media__image clicks in
   capture phase before the stock zoom-dialog fires.
   ============================================================ */

(function PLB() {
  'use strict';

  /* --- constants ----------------------------------------- */
  var ANIM_MS  = 400;
  var EASE_OUT = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var EASE_IN  = 'cubic-bezier(0.55, 0, 1, 0.45)';
  var ZOOM_MIN = 1, ZOOM_MAX = 5, ZOOM_STEP = 0.35;
  var SWIPE_PX = 55;

  /* --- state --------------------------------------------- */
  var items       = [];
  var idx         = 0;
  var isOpen      = false;
  var scale       = 1;
  var tx          = 0, ty = 0;
  var didDrag     = false;
  var mouseAnchor = null;
  var touchSwipe  = null;
  var touchPinch  = null;
  var lastTapTime = 0;

  /* --- DOM refs ------------------------------------------ */
  var el = {};

  /* --- boot --------------------------------------------- */
  function boot() {
    buildDOM();
    interceptClicks();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* --- helper: make SVG element -------------------------- */
  function mkSvg(pathD, strokeW) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', strokeW || '1.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', pathD);
    svg.appendChild(path);
    return svg;
  }

  /* --- helper: make button -------------------------------- */
  function mkBtn(id, label, svgPath, strokeW) {
    var b = document.createElement('button');
    b.id = id;
    b.setAttribute('aria-label', label);
    b.appendChild(mkSvg(svgPath, strokeW));
    return b;
  }

  /* --- helper: make div ---------------------------------- */
  function mkDiv(id) {
    var d = document.createElement('div');
    d.id = id;
    return d;
  }

  /* --- build lightbox DOM -------------------------------- */
  function buildDOM() {
    /* root overlay */
    var root = document.createElement('div');
    root.id = 'plb';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Image viewer');

    /* backdrop */
    var bd = mkDiv('plb-bd');

    /* stage -> flip -> zoom -> img */
    var stage   = mkDiv('plb-stage');
    var flip    = mkDiv('plb-flip');
    var zoom    = mkDiv('plb-zoom');
    var img     = document.createElement('img');
    img.id = 'plb-img';
    img.setAttribute('draggable', 'false');
    img.alt = '';
    var spinner = mkDiv('plb-spinner');

    zoom.appendChild(img);
    flip.appendChild(zoom);
    stage.appendChild(flip);
    stage.appendChild(spinner);

    /* buttons */
    var clBtn = mkBtn('plb-cl', 'Close', 'M18 6L6 18M6 6l12 12', '1.5');
    var pvBtn = mkBtn('plb-pv', 'Previous image', 'M15 18l-6-6 6-6', '1.8');
    var nxBtn = mkBtn('plb-nx', 'Next image',     'M9 18l6-6-6-6',   '1.8');

    /* counter + thumbs */
    var cnt    = mkDiv('plb-cnt');
    var thumbs = mkDiv('plb-thumbs');

    root.appendChild(bd);
    root.appendChild(stage);
    root.appendChild(clBtn);
    root.appendChild(pvBtn);
    root.appendChild(nxBtn);
    root.appendChild(cnt);
    root.appendChild(thumbs);
    document.body.appendChild(root);

    /* store refs */
    el.root    = root;
    el.bd      = bd;
    el.stage   = stage;
    el.flip    = flip;
    el.zoom    = zoom;
    el.img     = img;
    el.spinner = spinner;
    el.cl      = clBtn;
    el.pv      = pvBtn;
    el.nx      = nxBtn;
    el.cnt     = cnt;
    el.thumbs  = thumbs;

    /* control events */
    bd.addEventListener('click', closeLB);
    clBtn.addEventListener('click', closeLB);
    pvBtn.addEventListener('click', function() { navigate(-1); });
    nxBtn.addEventListener('click', function() { navigate(+1); });
    thumbs.addEventListener('click', onThumbClick);

    /* zoom/pan -- desktop */
    stage.addEventListener('wheel',     onWheel,      { passive: false });
    stage.addEventListener('mousedown', onMouseDown);
    zoom.addEventListener('click',      onZoomClick);

    /* zoom/pan/swipe -- touch */
    stage.addEventListener('touchstart', onTouchStart, { passive: false });
    stage.addEventListener('touchmove',  onTouchMove,  { passive: false });
    stage.addEventListener('touchend',   onTouchEnd);

    /* keyboard */
    document.addEventListener('keydown', onKey);
  }

  /* --- intercept product image clicks (capture phase) ---- */
  /* Use window (fires before document) so we always beat the
     theme's own zoom listener regardless of load order.       */
  function interceptClicks() {
    window.addEventListener('click', function(e) {
      /* bail if click is inside our own lightbox */
      if (e.target.closest('#plb')) return;

      /* match the img itself OR any product-media wrapper      */
      var imgEl = e.target.closest('.product-media__image');
      if (!imgEl) {
        /* also catch clicks on the surrounding media container */
        var wrap = e.target.closest('.product-media, product-media, .media-gallery__item');
        if (wrap) imgEl = wrap.querySelector('.product-media__image');
      }
      if (!imgEl) return;

      e.stopImmediatePropagation();
      e.preventDefault();
      collectImages(imgEl);
      var clickedWrap = imgEl.closest('.product-media');
      var clickedId = clickedWrap ? clickedWrap.dataset.mediaId : null;
      var startIdx = items.findIndex(function(it) {
        var wrap = it.el.closest('.product-media');
        return it.el === imgEl || (clickedId && wrap && wrap.dataset.mediaId === clickedId);
      });
      openLB(startIdx >= 0 ? startIdx : 0, imgEl);
    }, true);

    /* also block pointerdown / mousedown so fast zoom dialogs
       that open on press (not release) never get the chance    */
    window.addEventListener('pointerdown', function(e) {
      if (e.target.closest('#plb')) return;
      var imgEl = e.target.closest('.product-media__image');
      if (!imgEl) {
        var wrap = e.target.closest('.product-media, product-media, .media-gallery__item');
        if (wrap) imgEl = wrap.querySelector('.product-media__image');
      }
      if (!imgEl) return;
      e.stopImmediatePropagation();
    }, true);
  }

  /* --- collect gallery images ----------------------------- */
  function collectImages(clicked) {
    var gallery = clicked.closest('media-gallery')
                || clicked.closest('[data-media-gallery]')
                || clicked.closest('.product__media-gallery')
                || clicked.closest('.product-media-gallery')
                || document;

    /* The gallery also contains the (hidden) zoom-dialog copy of every image;
       count only the visible gallery images so the counter shows the real total. */
    var found = Array.from(gallery.querySelectorAll('.product-media__image')).filter(function(im) {
      return !im.closest('zoom-dialog');
    });
    items = found.map(function(im) {
      return {
        el:    im,
        thumb: im.currentSrc || im.src || '',
        src:   im.dataset.maxResolution
            || im.dataset.src
            || im.getAttribute('data-max-resolution')
            || im.currentSrc
            || im.src
            || ''
      };
    });

    if (items.length === 0) {
      items = [{
        el:    clicked,
        thumb: clicked.currentSrc || clicked.src,
        src:   clicked.dataset.maxResolution || clicked.currentSrc || clicked.src
      }];
    }
  }

  /* --- open with FLIP animation -------------------------- */
  function openLB(startIdx, sourceEl) {
    idx    = startIdx;
    isOpen = true;
    scale  = 1; tx = 0; ty = 0;

    /* close any native zoom/dialog that may have slipped through */
    document.querySelectorAll('zoom-dialog, dialog[open]').forEach(function(d) {
      try { if (typeof d.close === 'function') d.close(); } catch(ex) {}
      d.removeAttribute('open');
      d.setAttribute('aria-hidden', 'true');
    });
    /* also hide common zoom overlay patterns */
    document.querySelectorAll('.zoom-overlay, .product-media__zoom, [data-zoom]').forEach(function(z) {
      z.style.display = 'none';
    });

    var srcRect = sourceEl.getBoundingClientRect();

    el.root.classList.add('plb-active');
    el.root.style.opacity = '0';
    document.body.style.overflow = 'hidden';

    el.spinner.classList.add('plb-loading');

    el.zoom.style.transition = 'none';
    el.zoom.style.transform  = 'translate(0,0) scale(1)';

    loadImage(idx, function(destW, destH) {
      el.spinner.classList.remove('plb-loading');

      var vw = window.innerWidth, vh = window.innerHeight;
      var cx = vw / 2, cy = vh / 2;

      var srcCx = srcRect.left + srcRect.width  / 2;
      var srcCy = srcRect.top  + srcRect.height / 2;
      var flipTx = srcCx - cx;
      var flipTy = srcCy - cy;
      var flipSx = srcRect.width  / destW;
      var flipSy = srcRect.height / destH;

      el.flip.style.transition = 'none';
      el.flip.style.transform  = 'translate(' + flipTx + 'px,' + flipTy + 'px) scale(' + flipSx + ',' + flipSy + ')';
      el.flip.style.opacity    = '0.35';

      /* force reflow */
      el.flip.getBoundingClientRect();

      el.flip.style.transition = 'transform ' + ANIM_MS + 'ms ' + EASE_OUT + ', opacity ' + (ANIM_MS * 0.55) + 'ms ease';
      el.flip.style.transform  = 'translate(0,0) scale(1,1)';
      el.flip.style.opacity    = '1';

      el.root.style.transition = 'opacity ' + (ANIM_MS * 0.45) + 'ms ease';
      el.root.style.opacity    = '1';

      updateUI();
      buildThumbs();
    });
  }

  /* --- close --------------------------------------------- */
  function closeLB() {
    if (!isOpen) return;
    isOpen = false;

    el.flip.style.transition = 'transform ' + (ANIM_MS * 0.6) + 'ms ' + EASE_IN + ', opacity ' + (ANIM_MS * 0.45) + 'ms ease';
    el.flip.style.transform  = 'scale(0.88)';
    el.flip.style.opacity    = '0';
    el.root.style.transition = 'opacity ' + (ANIM_MS * 0.5) + 'ms ease';
    el.root.style.opacity    = '0';

    setTimeout(function() {
      el.root.classList.remove('plb-active');
      el.root.style.opacity    = '';
      el.root.style.transition = '';
      el.flip.style.transition = '';
      el.flip.style.transform  = '';
      el.flip.style.opacity    = '';
      el.zoom.style.transform  = '';
      el.zoom.style.transition = '';
      el.img.src               = '';
      el.img.style.width       = '';
      el.img.style.height      = '';
      el.zoom.classList.remove('plb-zoomed', 'plb-grabbing');
      document.body.style.overflow = '';
      scale = 1; tx = 0; ty = 0;
    }, ANIM_MS * 0.65);
  }

  /* --- navigate ------------------------------------------ */
  function navigate(dir) {
    if (!isOpen || items.length <= 1) return;
    idx = (idx + dir + items.length) % items.length;
    scale = 1; tx = 0; ty = 0;
    el.zoom.classList.remove('plb-zoomed');
    applyZoomTransform(false);

    el.img.style.transition = 'opacity 0.15s ease';
    el.img.style.opacity    = '0';
    el.spinner.classList.add('plb-loading');

    loadImage(idx, function() {
      el.spinner.classList.remove('plb-loading');
      el.img.style.opacity = '1';
      updateUI();
    });
  }

  /* --- load high-res image ------------------------------- */
  function loadImage(i, cb) {
    var item  = items[i];
    var hiSrc = item.src || item.thumb;
    var tmp   = new Image();

    tmp.onload = function() {
      var vw    = window.innerWidth, vh = window.innerHeight;
      var ratio = Math.min(
        (vw * 0.93) / (tmp.naturalWidth  || vw),
        (vh * 0.93) / (tmp.naturalHeight || vh),
        1
      );
      var w = Math.round((tmp.naturalWidth  || vw) * ratio);
      var h = Math.round((tmp.naturalHeight || vh) * ratio);
      el.img.src          = hiSrc;
      el.img.style.width  = w + 'px';
      el.img.style.height = h + 'px';
      if (cb) cb(w, h);
    };
    tmp.onerror = function() {
      el.img.src          = item.thumb;
      el.img.style.width  = '';
      el.img.style.height = '';
      if (cb) cb(window.innerWidth * 0.9, window.innerHeight * 0.9);
    };
    tmp.src = hiSrc;
  }

  /* --- update counter + nav visibility ------------------- */
  function updateUI() {
    var n = items.length;
    el.cnt.textContent  = n > 1 ? (idx + 1) + ' / ' + n : '';
    el.pv.style.display = n > 1 ? '' : 'none';
    el.nx.style.display = n > 1 ? '' : 'none';
    Array.from(el.thumbs.querySelectorAll('.plb-thumb')).forEach(function(t, i) {
      t.classList.toggle('plb-thumb--active', i === idx);
    });
  }

  /* --- build thumbnail strip ----------------------------- */
  function buildThumbs() {
    if (items.length <= 1) { el.thumbs.style.display = 'none'; return; }
    el.thumbs.style.display = '';
    el.thumbs.innerHTML = '';
    items.forEach(function(it, i) {
      var btn = document.createElement('button');
      btn.className = 'plb-thumb' + (i === idx ? ' plb-thumb--active' : '');
      btn.dataset.i = i;
      btn.setAttribute('aria-label', 'Go to image ' + (i + 1));
      var tImg = document.createElement('img');
      tImg.src = it.thumb;
      tImg.loading = 'lazy';
      tImg.alt = '';
      btn.appendChild(tImg);
      el.thumbs.appendChild(btn);
    });
  }

  function onThumbClick(e) {
    var btn = e.target.closest('.plb-thumb');
    if (!btn) return;
    var i = +btn.dataset.i;
    if (i !== idx) navigate(i - idx);
  }

  /* --- zoom / pan helpers -------------------------------- */
  function applyZoomTransform(animated) {
    var imgW = parseFloat(el.img.style.width)  || el.img.offsetWidth  || 0;
    var imgH = parseFloat(el.img.style.height) || el.img.offsetHeight || 0;
    var maxTx = Math.max(0, (imgW * scale - window.innerWidth)  / 2);
    var maxTy = Math.max(0, (imgH * scale - window.innerHeight) / 2);
    tx = Math.max(-maxTx, Math.min(maxTx, tx));
    ty = Math.max(-maxTy, Math.min(maxTy, ty));

    el.zoom.style.transition = animated === false ? 'none' : 'transform 0.15s ease';
    el.zoom.style.transform  = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    el.zoom.classList.toggle('plb-zoomed', scale > 1);
  }

  function zoomTo(newScale, vpX, vpY) {
    var vw = window.innerWidth, vh = window.innerHeight;
    var ox = vpX - vw / 2 - tx;
    var oy = vpY - vh / 2 - ty;
    var ratio = newScale / scale;
    tx = tx - ox * (ratio - 1);
    ty = ty - oy * (ratio - 1);
    scale = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, newScale));
    applyZoomTransform();
  }

  /* --- wheel zoom ---------------------------------------- */
  function onWheel(e) {
    if (!isOpen) return;
    e.preventDefault();
    zoomTo(scale + (e.deltaY < 0 ? ZOOM_STEP : -ZOOM_STEP), e.clientX, e.clientY);
  }

  /* --- click on image to toggle zoom --------------------- */
  function onZoomClick(e) {
    if (didDrag) { didDrag = false; return; }
    if (e.target.closest('button')) return;
    if (scale > 1) { scale = 1; tx = 0; ty = 0; applyZoomTransform(); }
    else             { zoomTo(2.5, e.clientX, e.clientY); }
  }

  /* --- mouse drag (desktop pan when zoomed) -------------- */
  function onMouseDown(e) {
    if (!isOpen) return;
    if (e.button !== 0) return;
    if (e.target.closest('button')) return;
    if (scale <= 1) return;

    e.preventDefault();
    mouseAnchor = { x: e.clientX, y: e.clientY, tx: tx, ty: ty };
    didDrag = false;
    el.zoom.classList.add('plb-grabbing');
    el.zoom.style.transition = 'none';

    function onMove(e) {
      if (!mouseAnchor) return;
      var dx = e.clientX - mouseAnchor.x;
      var dy = e.clientY - mouseAnchor.y;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) didDrag = true;
      tx = mouseAnchor.tx + dx;
      ty = mouseAnchor.ty + dy;
      applyZoomTransform(false);
    }
    function onUp() {
      mouseAnchor = null;
      el.zoom.classList.remove('plb-grabbing');
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup',   onUp);
    }
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup',   onUp);
  }

  /* --- touch: pinch + swipe + double-tap ----------------- */
  function onTouchStart(e) {
    if (!isOpen) return;

    if (e.touches.length === 2) {
      e.preventDefault();
      touchSwipe = null;
      var t0 = e.touches[0], t1 = e.touches[1];
      touchPinch = {
        dist:  Math.hypot(t0.clientX - t1.clientX, t0.clientY - t1.clientY),
        scale: scale, tx: tx, ty: ty,
        cx: (t0.clientX + t1.clientX) / 2,
        cy: (t0.clientY + t1.clientY) / 2
      };

    } else if (e.touches.length === 1) {
      var t = e.touches[0];
      touchSwipe = { startX: t.clientX, startY: t.clientY, startTx: tx, startTy: ty, moved: false };
      touchPinch = null;

      var now = Date.now();
      if (now - lastTapTime < 280) {
        e.preventDefault();
        if (scale > 1) { scale = 1; tx = 0; ty = 0; applyZoomTransform(); }
        else            { zoomTo(2.5, t.clientX, t.clientY); }
        lastTapTime = 0;
      } else {
        lastTapTime = now;
      }
    }
  }

  function onTouchMove(e) {
    if (!isOpen) return;
    e.preventDefault();

    if (e.touches.length === 2 && touchPinch) {
      var t0 = e.touches[0], t1 = e.touches[1];
      var dist  = Math.hypot(t0.clientX - t1.clientX, t0.clientY - t1.clientY);
      var ratio = dist / touchPinch.dist;
      var newScale = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, touchPinch.scale * ratio));

      var curCx = (t0.clientX + t1.clientX) / 2;
      var curCy = (t0.clientY + t1.clientY) / 2;
      var vw = window.innerWidth, vh = window.innerHeight;
      var ox = touchPinch.cx - vw / 2 - touchPinch.tx;
      var oy = touchPinch.cy - vh / 2 - touchPinch.ty;
      var sr = newScale / touchPinch.scale;
      tx = touchPinch.tx - ox * (sr - 1) + (curCx - touchPinch.cx);
      ty = touchPinch.ty - oy * (sr - 1) + (curCy - touchPinch.cy);
      scale = newScale;
      el.zoom.style.transition = 'none';
      applyZoomTransform(false);

    } else if (e.touches.length === 1 && touchSwipe) {
      var t = e.touches[0];
      var dx = t.clientX - touchSwipe.startX;
      var dy = t.clientY - touchSwipe.startY;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) touchSwipe.moved = true;

      if (scale > 1) {
        tx = touchSwipe.startTx + dx;
        ty = touchSwipe.startTy + dy;
        applyZoomTransform(false);
      }
    }
  }

  function onTouchEnd(e) {
    if (!isOpen) return;

    if (e.touches.length === 0 && touchSwipe && touchSwipe.moved && scale <= 1) {
      var t  = e.changedTouches[0];
      var dx = t.clientX - touchSwipe.startX;
      var dy = t.clientY - touchSwipe.startY;
      if (Math.abs(dx) > SWIPE_PX && Math.abs(dy) < 90) {
        navigate(dx < 0 ? 1 : -1);
      }
    }

    if (e.touches.length === 0) { touchPinch = null; touchSwipe = null; }
    if (e.touches.length === 1) { touchPinch = null; }
  }

  /* --- keyboard ------------------------------------------ */
  function onKey(e) {
    if (!isOpen) return;
    switch (e.key) {
      case 'Escape':     e.preventDefault(); closeLB();  break;
      case 'ArrowLeft':  e.preventDefault(); navigate(-1); break;
      case 'ArrowRight': e.preventDefault(); navigate(+1); break;
      case '+': case '=': zoomTo(scale + ZOOM_STEP, window.innerWidth/2, window.innerHeight/2); break;
      case '-':           zoomTo(scale - ZOOM_STEP, window.innerWidth/2, window.innerHeight/2); break;
      case '0':           scale=1; tx=0; ty=0; applyZoomTransform(); break;
    }
  }

})();
